module.exports = __webpack_public_path__ + "static/media/12.score.7ad81f7a.mp4";